var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMRecibos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0b5c96;}.cls-3{fill:#329be6;}.cls-4{fill:#2eccb6;}.cls-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_recibos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recibos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.17,21.62V12.74h-23V53.42H49V21.62Zm-15-4.54a4,4,0,1,1-4,4A4,4,0,0,1,25.19,17.08Zm15.89,34a4,4,0,1,1,4-4A4,4,0,0,1,41.08,51.08Zm4-10.4a.4.4,0,0,1-.4.4H21.42a.4.4,0,0,1-.4-.4v-8.2a.4.4,0,0,1,.4-.4h23.3a.4.4,0,0,1,.4.4Zm0-11a.4.4,0,0,1-.4.4H21.42a.4.4,0,0,1-.4-.4V27.5a.4.4,0,0,1,.4-.4h23.3a.4.4,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.12,50.12l-2.5-2.5V18.54l2.5-2.5Zm26.12,5.8H22.92l-2.5-2.5H45.74Zm8.3-34.3v26L49,50.12V21.62H40.57a.4.4,0,0,1-.4-.4V12.74H20.42l2.5-2.5H41.21l.73.73,8.87,8.88.73.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.12,27.5v2.18a.4.4,0,0,1-.4.4H21.42a.4.4,0,0,1-.4-.4V27.5a.4.4,0,0,1,.4-.4h23.3A.4.4,0,0,1,45.12,27.5Zm0,5v8.2a.4.4,0,0,1-.4.4H21.42a.4.4,0,0,1-.4-.4v-8.2a.4.4,0,0,1,.4-.4h23.3A.4.4,0,0,1,45.12,32.48ZM29.17,21.08a4,4,0,1,1-4-4A4,4,0,0,1,29.17,21.08ZM14.62,12.74v-2.1a.4.4,0,0,1,.4-.4h7.9l-2.5,2.5h-3.3V16l-2.5,2.5Zm2.5,43.18H15a.4.4,0,0,1-.4-.4v-7.9l2.5,2.5v3.3h3.3l2.5,2.5Zm20-8.84a4,4,0,1,1,4,4A4,4,0,0,1,37.11,47.08Zm14.43,6.34v2.1a.39.39,0,0,1-.4.4h-7.9l2.5-2.5H49v-3.3l2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.62,47.62.37,33.37a.4.4,0,0,1,0-.57L14.62,18.54ZM33.37,65.8a.4.4,0,0,1-.57,0l-9.88-9.88H43.24ZM65.8,33.37,51.54,47.62v-27l-.73-.73L41.94,11l-.73-.73H22.92L32.8.37a.4.4,0,0,1,.57,0L65.8,32.8A.4.4,0,0,1,65.8,33.37Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMRecibos);
export default __webpack_public_path__ + "static/media/m_recibos.892e519ce938e906019a58950503f64e.svg";
export { ForwardRef as ReactComponent };